import { render, staticRenderFns } from "./SubjectListCustom.vue?vue&type=template&id=58860dd6&"
import script from "./SubjectListCustom.vue?vue&type=script&lang=js&"
export * from "./SubjectListCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports